import axios from '../axiosInstance.js';

// Submit contact form
export const submitContactForm = (formData) => {
  return axios.post('/contacts', formData);
};

export const submitQuoteForm = (formData) => {
  return axios.post('/request-a-quote', formData);
};

export const submitSubscribeForm = (formData) => {
  return axios.post('/subscribe', formData);
};